import { ContentV2, FileContentItem, LinkContentItem } from '@front-app/services/GroupsApi/DiscussionModel';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { isAdminRole, canEditOrDeleteGroupFiles } from '@front-app/util/permission';

const canDeleteContent = (content: ContentV2) => {
	const { currentUser, isCsr } = CurrentUserStore;
	const group = GroupsStore.getInstance().groupById(content.groupId);

	if (!canEditOrDeleteGroupFiles(group)) {
		return false;
	}

	return isCsr.value
		|| isAdminRole(group?.role)
		|| content.creator.id === currentUser.value.id;
};

export const canDeleteFile = (file: FileContentItem): boolean => canDeleteContent(file);

export const canDeleteLink = (link: LinkContentItem): boolean => canDeleteContent(link);

export const canEditContent = (content: ContentV2): boolean => {
	const { currentUser, isCsr } = CurrentUserStore;
	const group = GroupsStore.getInstance().groupById(content.groupId);

	if (!canEditOrDeleteGroupFiles(group)) {
		return false;
	}

	return isCsr.value
		|| isAdminRole(group?.role)
		|| content.creator.id === currentUser.value.id;
};

export const canEditFile = (file: FileContentItem): boolean => canEditContent(file);

export const canEditLink = (link: LinkContentItem): boolean => canEditContent(link);
